import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { checkIsActive } from '../../utils';
import { useLayout } from '../../layout/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './AsideMenuItem.scss';

type Props = {
	to?: string;
	title?: string;
	icon?: any;
	fontIcon?: string;
	hasBullet?: boolean;
	isLink?: boolean;
	linkTitle?: string;
	link?: string;
	children?: React.ReactElement;
}

const AsideMenuItem = (
	{
		children,
		to,
		title,
		icon,
		fontIcon,
		hasBullet = false,
		isLink = false,
		linkTitle,
	}: Props): React.ReactElement => {
	const { pathname } = useLocation();
	const isActive = checkIsActive(pathname, to);
	const { config } = useLayout();
	const { aside } = config;

	return (
		<div className="menu-item">
			{
				isLink ? (
					<div className="menu-link without-sub">
						<span className="menu-bullet">
							<span className="bullet bullet-dot"/>
						</span>
						<a href={to} className="menu-title" target="_blank" rel="noreferrer">{linkTitle}</a>
					</div>
				) : (
					<Link className={clsx('menu-link without-sub', { active: isActive })} to={to}>
						{
							hasBullet && (
								<span className="menu-bullet">
									<span className="bullet bullet-dot"/>
								</span>
							)
						}
						{icon && <FontAwesomeIcon icon={icon} className={clsx('me-3 menu-icon', isActive ? 'text-danger' : 'text-muted')}/>}
						{fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}/>}
						<span className="menu-title">{title}</span>
					</Link>
				)
			}
			{children}
		</div>
	);
};

export { AsideMenuItem };
